// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import global from '@/components/global'
import utils from '../static/js/utils.js'
import "./utils/interceptors"
import {Base64} from 'js-base64'
import store from './store'
import permission from './directive/permission'
import getSign from './plugin/sign'

import ElementUI from 'element-ui';
import axios from 'axios'
import { VuePlugin } from 'vuera'
import $ from 'jquery'
import qs from 'qs'
import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
import './plugin/vxe_table_plugin/filter'
import VueClipboard from 'vue-clipboard2'
import vueCookies from 'vue-cookies'

import "../static/theme/index.css";
import 'font-awesome/css/font-awesome.min.css'
import 'amis/lib/themes/default.css';
// import 'amis/lib/themes/ang.css';
// import 'amis/lib/themes/antd.css';
// import 'amis/lib/themes/cxd.css';
// import 'amis/lib/themes/dark.css';
import 'amis/lib/helper.css';
// import 'amis-editor/dist/style.css';
import 'amis-editor-core/lib/style.css'
import 'vxe-table-plugin-element/dist/style.css'
import 'vxe-table/lib/index.css'
import 'amis-ext/dist/index.css'
// import '../static/css/amis-patch.css'

import '../static/iconfont/iconfont.css'

/* 这些模块可以不在此引用，为观察有无未知影响，暂时保留此注释  Ryan 2021-4/6，
import 'xe-utils'
import Contextmenu  from 'vue-contextmenujs'

import Blob from './vendor/Blob.js'
import Export2Excel from './vendor/Export2Excel.js'

Vue.use(Contextmenu);
Vue.prototype.$XModal = VXETable.modal
store.commit('INIT_COLOR');
*/

Vue.use(VuePlugin)
Vue.use(ElementUI);
Vue.use(utils);
Vue.use(permission);
Vue.use(VXETable);
Vue.use(VueClipboard)
VXETable.use(VXETablePluginElement)

Vue.config.productionTip = false;
axios.defaults.withCredentials = true;
Vue.prototype.$ajax = axios;
Vue.prototype.$store = store;
axios.defaults.baseURL = '/api';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.userURL = '/api';

//计算得到sign值
Vue.use(getSign);
//设置cookies
Vue.use(vueCookies);

Vue.prototype.$qs = qs;

//Renderer({test: /(^|\/)hl-select-icon/, name: 'hl-select-icon'})(HlIconSelectComponent);
//registerEditorPlugin(HlIconSelectPlugin);

//Renderer({test: /(^|\/)hl-custom/, name: 'hl-custom'})(HlCustom);
//registerEditorPlugin(HlCustomPlugin);

//Renderer({test: /(^|\/)amis-example/, name: 'amis-example'})(ExampleComponent);
//registerEditorPlugin(ExamplePlugin);


window.Vue = Vue;
window.Vue.prototype.global = global;
let hostname = document.location.host;
let proto = document.location.protocol;
// console.log(document.location)
$.ajax({
    url: proto + '//' + hostname + '/static/project.config.json.BSF',
    type: 'GET',
    async: true, //  或false,是否异步
    data: {},
    dataType: 'html', //  返回的数据格式
    success: function (response) {
      if (response.startsWith("BSF(") && response.endsWith(")")) {
        response = Base64.decode(response.substring(4, response.length - 1));
      }
      let pConfig = JSON.parse(response);
      pConfig.app_sub_path = '/app342';
      window.Vue.prototype.baseConfig = pConfig;
      window.Vue.prototype.vm = new Vue({
        el: '#app',
        router,
        components: { App },
        template: '<App/>'
      })
    },
    error: function (error) {
      console.log('get baseConfig error:==========')
      console.log( error)
    },
    complete: function () {
      }
    });

// 根据路由设置标题
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next();
});
